import { HasKind } from '@/utilities/HasKind';

import { Crumbs } from '../../bakery/Crumbs';

export const kind = 'TaskFailed';

export interface TaskFailed extends HasKind<typeof kind> {
  reason: unknown;
}

export function crumble(action: TaskFailed): Crumbs {
  return {
    reason: JSON.stringify(action.reason, null, 2),
    type: typeof action,
  };
}
